import { clickbounds } from './clickbounds.js';
import { colors } from './colors.js';
import { elevation } from './elevation.js';
import { interactions } from './interactions.js';
import { shape } from './shape.js';
import { typography } from './typography.js';
import { spacings } from './spacings.js';

var tokens = {
  clickbounds: clickbounds,
  colors: colors,
  elevation: elevation,
  interactions: interactions,
  shape: shape,
  typography: typography,
  spacings: spacings
};

export { tokens };
